import styles from './TaskListLoader.module.css';

export default function TaskListLoader(){
  return (
    <>
    <tr className={styles['table-body-row']}>
        <td className={styles['row-id']}>
            <div className={styles['text-loading']}>
                곧
            </div>
        </td>
        <td className={styles['row-name']}>
            <div className={styles['text-loading']}>
            로딩이
            </div>
        </td>
        <td className={styles['row-date']}>
            <div className={styles['text-loading']}>
            완료
            </div>
        </td>
        <td className={styles['row-user']}>
            <div className={styles['text-loading']}>
            됩니다.
            </div>
        </td>
        <td className={styles['row-devices']}>
            <div className={styles['text-loading']}>
            차 한잔
            </div>
        </td>
        <td className={styles['row-data']}>
            <div className={styles['text-loading']}>
            어떠세요?
            </div>
        </td>
        <td className={styles['row-rounds']}>
            <div className={styles['text-loading']}>
            from JSR
            </div>
        </td>
        <td className={styles['row-status']}>
            <div className={styles['row-status-wrap']}>
                <div className={styles['status-dot']}></div>
                <span className={styles['status-text']}>loading</span>
                <span className={styles['status-arrow']}>&gt;</span>
            </div>
        </td>
    </tr>
    <tr className={styles['body-hr']}></tr>
    </>
  );
}